export const GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';
export const GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
export const GET_VENDORS_FAILURE = 'GET_VENDORS_FAILURE';

export const ADD_VENDOR_SUCCESS = 'ADD_VENDOR_SUCCESS';
export const ADD_VENDOR_REQUEST = 'ADD_VENDOR_REQUEST';
export const ADD_VENDOR_FAILURE = 'ADD_VENDOR_FAILURE';

export const UPDATE_VENDOR_SUCCESS = 'UPDATE_VENDOR_SUCCESS';
export const UPDATE_VENDOR_REQUEST = 'UPDATE_VENDOR_REQUEST';
export const UPDATE_VENDOR_FAILURE = 'UPDATE_VENDOR_FAILURE';

export const ADD_PENALTY_SUCCESS = 'ADD_PENALTY_SUCCESS';
export const ADD_PENALTY_REQUEST = 'ADD_PENALTY_REQUEST';
export const ADD_PENALTY_FAILURE = 'ADD_PENALTY_FAILURE';

export const APPROVED_VENDOR_SUCCESS = 'APPROVED_VENDOR_SUCCESS';
export const APPROVED_VENDOR_REQUEST = 'APPROVED_VENDOR_REQUEST';
export const APPROVED_VENDOR_FAILURE = 'APPROVED_VENDOR_FAILURE';

export const BLOCKED_VENDOR_SUCCESS = 'BLOCKED_VENDOR_SUCCESS';
export const BLOCKED_VENDOR_REQUEST = 'BLOCKED_VENDOR_REQUEST';
export const BLOCKED_VENDOR_FAILURE = 'BLOCKED_VENDOR_FAILURE';

export const UNBLOCKED_VENDOR_SUCCESS = 'UNBLOCKED_VENDOR_SUCCESS';
export const UNBLOCKED_VENDOR_REQUEST = 'UNBLOCKED_VENDOR_REQUEST';
export const UNBLOCKED_VENDOR_FAILURE = 'UNBLOCKED_VENDOR_FAILURE';

export const DELETE_VENDOR_SUCCESS = 'DELETE_VENDOR_SUCCESS';
export const DELETE_VENDOR_REQUEST = 'DELETE_VENDOR_REQUEST';
export const DELETE_VENDOR_FAILURE = 'DELETE_VENDOR_FAILURE';

